import React, { useEffect } from 'react';

import { Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { ListCard } from 'components/Card';
import { ImageAvatar } from 'components/Avatar';

import { isoToDateString } from 'utils/dateFormatter';

import { useAuth } from 'lib/auth';

export const SubscriptionsListItem = ({
  id,
  company_id,
  user_id,
  subscription_level,
  invoice_period,
  number_of_users,
  promo_code,
  created_on,
  companyType,
  Company,
  User
}) => {
  const { account } = useAuth();

  return (
    <ListCard
    sx={{
      '& .MuiTypography-body2': {
        fontSize: {md: "0.75rem", lg: "0.875rem"},
      },
      '& .MuiTypography-caption': {
        fontSize: {md: "0.625rem", lg: "0.75rem"},
      }
    }}
    >
      {account.super_admin && (
        <>
          <ImageAvatar img={Company.square_logo_url || ''} name={Company.Name} sx={{alignSelf: 'center'}}/>
          <Stack justifyContent="center" flex={{md: 1.7, xl: 1.7}} pr={1}>
            <Link
              component={RouterLink}
              to={`/app/${Company.Type}s/${company_id.toString()}?tab=framework agreements`}
              underline="none"
              color="inherit"
            >
              <Typography variant="caption" fontWeight={700}>
                Organization
              </Typography>

              <Typography variant="body2" fontWeight={700}>
                {`${Company.Name}`}
              </Typography>
            </Link>
          </Stack>
          <Stack justifyContent="center" flex={{md: 0.7, lg: 0.5, xl: 0.3}} pr={1}>
            <Typography variant="caption" fontWeight={700}>
              Type
            </Typography>

            <Typography variant="body2" fontWeight={700} sx={{textTransform: 'capitalize'}}>
            {`${Company.Type}`}
            </Typography>
          </Stack>
          <Stack justifyContent="center" flex={{md: 1.6, lg: 1.25, xl: 0.7}} pr={1}>
            <Typography variant="caption" fontWeight={700}>
              User
            </Typography>
            <Typography variant="body2" fontWeight={700} height={0.5}>
              <Link
                component={RouterLink}
                to={`/app/contacts/${user_id.toString()}`}
                underline="none"
                color="inherit"
              >
                {`${User.first_name} ${User.last_name}`}
              </Link>
            </Typography>
            
          </Stack>
          <Stack justifyContent="center" flex={{md: 0.7, lg: 0.6, xl: 0.4}} pr={1}>
            <Typography variant="caption" fontWeight={700}>
              Subscription
            </Typography>

            <Typography variant="body2" fontWeight={700} sx={{textTransform: 'capitalize'}}>
              {`${subscription_level}`}
            </Typography>
          </Stack>
          <Stack justifyContent="center" flex={{md: 0.7, lg: 0.5, xl: 0.3}} pr={1}>
            <Typography variant="caption" fontWeight={700}>
              Period
            </Typography>

            <Typography variant="body2" fontWeight={700} sx={{textTransform: 'capitalize'}} height={0.5}>
              {`${invoice_period}`}
            </Typography>
          </Stack>
          <Stack justifyContent="center" flex={{md: 0.4, lg: 0.4, xl: 0.2}} pr={1}>
            <Typography variant="caption" fontWeight={700}>
              Users
            </Typography>

            <Typography variant="body2" fontWeight={700}>
              {`${number_of_users}`}
            </Typography>
          </Stack>
          <Stack justifyContent="center" flex={{md: 0.9, lg: 0.7, xl: 0.35}} pr={1}>
            <Typography variant="caption" fontWeight={700}>
              Promo code
            </Typography>

            <Typography variant="body2" fontWeight={700} height={0.5}>
              {`${promo_code}`}
            </Typography>
          </Stack>
          <Stack justifyContent="center" flex={{md: 1.5, lg: 1.1, xl: 0.6}} pr={1}>
            <Typography variant="caption" fontWeight={700}>
              Date and time
            </Typography>

            <Typography variant="body2" fontWeight={700}>
              {isoToDateString(created_on, true)}
            </Typography>
          </Stack>
        </>
      )}
    </ListCard>
  );
};
